import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, watch, onMounted, onUnmounted, computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'count-up',
  props: {
    endValue: {},
    duration: { default: 1500 },
    decimals: { default: 0 }
  },
  setup(__props: any) {

const props = __props

const displayValue = ref(0)
let animationFrame: number | null = null
let startTime: number | null = null

function animate(currentTime: number) {
  if (startTime === null) {
    startTime = currentTime
  }

  const elapsed = currentTime - startTime
  const progress = Math.min(elapsed / props.duration, 1)

  // 使用缓动函数（ease-out）
  const easeOut = 1 - Math.pow(1 - progress, 3)
  const currentValue = props.endValue * easeOut
  
  // 根据是否有小数来决定是否使用 Math.floor
  if (props.decimals > 0) {
    displayValue.value = Number(currentValue.toFixed(props.decimals))
  } else {
    displayValue.value = Math.floor(currentValue)
  }

  if (progress < 1) {
    animationFrame = requestAnimationFrame(animate)
  } else {
    displayValue.value = props.endValue
  }
}

function startAnimation() {
  if (animationFrame !== null) {
    cancelAnimationFrame(animationFrame)
  }
  displayValue.value = 0
  startTime = null
  animationFrame = requestAnimationFrame(animate)
}

watch(() => props.endValue, () => {
  startAnimation()
}, { immediate: true })

onMounted(() => {
  startAnimation()
})

onUnmounted(() => {
  if (animationFrame !== null) {
    cancelAnimationFrame(animationFrame)
  }
})

const formattedValue = computed(() => {
  if (props.decimals > 0) {
    return displayValue.value.toFixed(props.decimals)
  }
  return displayValue.value.toLocaleString()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, _toDisplayString(formattedValue.value), 1))
}
}

})